module.exports = __webpack_public_path__ + "static/media/stofferingen-24.5001a6cd.jpg";